import { Column, Container, Row } from "lcm-iot-commons";
import NavigationLegalPages from "../NavigationLegalPages";

/* eslint-disable react/no-unescaped-entities */
export default function Imprint() {
  return (
    <Container>
      <Row>
        <NavigationLegalPages />
        <Column md={9}>
          <h1>Imprint</h1>
          <h2>
            This website is provided by Endress+Hauser Process Solutions AG
          </h2>
          <p>
            The Endress+Hauser Process Solutions AG is a company limited by
            shares under Swiss law and with its registered seat in Reinach
            BL/Switzerland. The company is registered in the commercial register
            of the canton Basel-Landschaft with the business identification
            number CHE-105.329.554.
          </p>
          <ul>
            <li>
              Address: Endress+Hauser Process Solutions AG,
              Christoph-Merian-Ring 12, 4153 Reinach BL, Switzerland
            </li>
            <li>
              E-Mail:{" "}
              <a href="mailto:netilion@endress.com">netilion@endress.com</a>
            </li>
            <li>
              <a
                href="https://www.endress.com/en/field-instruments-overview/netilion-iiot"
                target="_blank"
                rel="noreferrer"
              >
                Contact us
              </a>
            </li>
          </ul>
          <p>Responsible for content: Managing Director, Rolf Birkhofer.</p>
          <p>
            The value added tax number of the Endress+Hauser Process Solutions
            AG is CHE-105.329.554 MWST. The use of this website is governed by
            our General Terms of Service which can be found under the menu item
            ”Terms of Service” at the bottom of the page.
          </p>
        </Column>
      </Row>
    </Container>
  );
}
